import React, { useState, useEffect, useRef } from 'react'
import {
    Box, Modal, Button,
} from "@mui/material";
import { reCalibrateHeadingIcon } from ".././icons";
import { useRive } from '@rive-app/react-canvas';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { deepCopy, checkSeasonsRoomTypeDiff } from '../../../../app/util';
import { getPropertyInfo } from '../../../../actions/appstate';


function UpdateRequiredPopup(props) {
    // console.log(propertyInfo.system_settings[0].pricing_settings.room_dow_plans.length);
    const { app, auth } = useSelector((state) => state);
    const { app_state, ui_state } = app.current_state;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const propertyInfo = getPropertyInfo(auth.profile.property_details, app_state.property_id);
    const { pricing_settings } = propertyInfo?.system_settings && propertyInfo?.system_settings[0] ? propertyInfo?.system_settings[0] : {};
    // const {isRoomTypeDifference, initial } = app_state?.pricingSeasons;
    const { pricing_model, isNewRoomTypeAdded } = props
    const isSeasonConfigured = Boolean(pricing_settings?.room_dow_plans?.length && pricing_settings?.room_dow_plans[0].status);
    let isRoomTypeDifference = checkSeasonsRoomTypeDiff(pricing_settings?.room_dow_plans, ['active', 'inactive', 'expired'], pricing_model);
    const [openPopup, setOpenPopup] = useState(isRoomTypeDifference || !isSeasonConfigured)

    const handleClickUpdateNow = () => {
        setOpenPopup(false);
        ui_state.isFromHeader = false;
        ui_state.active_settings_menu = "propertySettingsMenu"
        ui_state.activeSettingsComponentName = "DefaultRoomTypePricing"
        ui_state.settingsActiveIndex = 12;

        dispatch({
            type: "UPDATE_STATE",
            payload: {
                ui_state: deepCopy(ui_state)
            },
        });
        navigate("/settings");

    }

    const handleClose = () => {
        setOpenPopup(false);
        props.onClosePopup();
    }

    let popupText = "";
    let popupHeadText = "";
    if (isRoomTypeDifference) {
        // popupText = "You've Made Changes to Your Room Type Configuration. Please Review and Update Your Pricing Seasons to Keep Pricing Recommendations on Track.";
        popupText = "You've made changes to your Room Type Configuration under Inventory Settings. Please review and update your Pricing Seasons to keep Pricing Recommendations on track. You would be able to send rates only after pricing seasons are updated.";
        popupHeadText = "Pricing Seasons Review Required";
    }

    if (isNewRoomTypeAdded) {
        popupText = "A new room type has been added. Please update your pricing seasons to include this room type and ensure accurate rate recommendations.";
        popupHeadText = "Update Required for New Room Type";
    }
    if (!isSeasonConfigured) {
        // popupText = " Differentials for the New Room Types Are Missing in Your Pricing Seasons. Please Update All Active Seasons to Enable Auto Rate Push."
        popupText = "Create a Pricing Season to Unlock Rate Recommendations, Enable Auto Rate Push, and Activate Pricing."
        popupHeadText = "Set Up a Pricing Season";
    }

    useEffect(() => {
        setOpenPopup(props.open);
    }, [props.open]);

    if (pricing_model === 0) return false;
    return (
        <Modal
            open={openPopup}
            //onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box className="pricing-seasons-popup" sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '540px',
                //height: '200px',
                bgcolor: '#fff',
                borderRadius: '8px',
            }}>
                <Box className="popup-container">
                    {/* <div className='rive-animated-icon'>
                        <PricingSeasonsIcon  />
                    </div> */}
                    <svg width="66" height="79" viewBox="0 0 66 79" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 67.2871H64.9192" stroke="#606060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M1 67.2871V77.3581H64.9192V67.2871" stroke="#606060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M1 67.2888V64.468C1.16628 62.1809 2.21686 60.0462 3.93256 58.5367C5.64826 57.0272 7.87791 56.2648 10.1529 56.4021H55.7738C58.0413 56.2572 60.2785 57.0272 61.9942 58.5367C63.7099 60.0462 64.7605 62.1732 64.9267 64.468V67.2888" stroke="#606060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.8257 56.4098V45.9729C10.6972 44.7455 11.0373 43.5104 11.7855 42.5346C12.5262 41.5511 13.6146 40.8955 14.8239 40.6973H50.778C51.9873 40.8955 53.0756 41.5511 53.8163 42.5346C54.557 43.5181 54.9047 44.7455 54.7762 45.9729V56.4098" stroke="#606060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M35.1173 55.9674V51.416C35.1022 50.9052 35.2911 50.4021 35.6313 50.0209C35.9714 49.6397 36.4475 49.4034 36.9539 49.3652H45.6609C46.19 49.3652 46.6964 49.5787 47.0743 49.9523C47.4522 50.3258 47.6563 50.8442 47.6563 51.3779V55.9293" stroke="#606060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M18.2175 55.9684V51.417C18.2175 50.8833 18.4292 50.3725 18.7995 49.9913C19.1774 49.6101 19.6838 49.4043 20.2129 49.4043H28.9652C29.4943 49.4043 30.0007 49.6178 30.3786 49.9913C30.7565 50.3725 30.9606 50.8833 30.9606 51.417V55.9684" stroke="#606060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M32.8423 1V33.2333" stroke="#606060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M40.952 9.05918L39.3119 7.40482C38.5561 6.63482 37.6491 6.03254 36.659 5.62086C35.6613 5.20918 34.5956 5.01096 33.5224 5.02621H30.8468C29.2747 5.0567 27.7857 5.71235 26.6898 6.84066C25.5939 7.96898 24.9741 9.49373 24.9741 11.0719C24.9741 12.6576 25.5863 14.1747 26.6898 15.303C27.7857 16.4314 29.2823 17.087 30.8468 17.1175H34.845C35.6387 17.1022 36.4323 17.2471 37.173 17.5444C37.9137 17.8418 38.5863 18.2839 39.1607 18.8481C39.7276 19.4122 40.1811 20.0831 40.491 20.8226C40.8009 21.5621 40.9596 22.3626 40.9596 23.1631C40.9596 23.9636 40.8009 24.7641 40.491 25.5036C40.1811 26.2431 39.7276 26.914 39.1607 27.4782C38.5939 28.0423 37.9137 28.4845 37.173 28.7818C36.4323 29.0792 35.6387 29.224 34.845 29.2088H32.1695C30.0532 29.2012 28.0276 28.3473 26.5387 26.8302L24.9817 25.1758" stroke="#606060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M64.9195 33.9658C63.7631 34.8425 62.3724 35.3381 60.9212 35.3762C58.5404 35.056 56.3712 33.8133 54.8823 31.9074C53.3933 30.0014 52.6904 27.5923 52.9323 25.1832C52.6904 22.7741 53.3933 20.3574 54.8823 18.459C56.3712 16.5531 58.5404 15.3104 60.9212 14.9902C62.3648 15.0284 63.7631 15.5239 64.9195 16.4006" stroke="#606060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M60.8073 21.1484H48.8201" stroke="#606060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M60.8073 29.207H48.8201" stroke="#606060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M2.87476 34.041H14.7032" stroke="#606060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M6.87231 34.0412V19.9373C6.87231 18.8699 7.29557 17.8407 8.04383 17.086C8.79208 16.3312 9.81243 15.9043 10.8706 15.9043H14.8688" stroke="#606060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M2.87476 25.9824H14.862" stroke="#606060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <Box>
                        <div className='popup-title'>{popupHeadText}</div>
                        <div className='popup-msg'>{popupText}</div>
                    </Box>
                    <Box className="action-buttons">
                        <Button className='btn-group navigate-cancel-button' onClick={handleClose}>Later</Button>
                        <Button className='btn-group navigate-save-button' onClick={handleClickUpdateNow} >{(!isSeasonConfigured) ? "Configure Now" : "Update Seasons"}</Button>
                    </Box>
                </Box>
            </Box>

        </Modal>
    )
}

export default UpdateRequiredPopup

function PricingSeasonsIcon() {
    const { rive, RiveComponent } = useRive({
        src: 'assets/rive/pricing_seasons.riv',
        stateMachines: "State Machine 1",
        autoplay: true,
    });

    return (
        <RiveComponent />
    );
}